
















































import { defineComponent, ref, useFetch } from "@nuxtjs/composition-api";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";

export default defineComponent({
  name: "HeaderMegaMenu",

  setup() {
    const categoryTree = ref([]);
    const hoveredCategory = ref<string | null>(null);
    const categories = useCategoryStore();

    useFetch(async () => {
      if (!categories.categories || !categories.categories.children?.length) {
        await categories.load();
      }
      categoryTree.value = categories.categories.children || [];
    });

    return {
      categoryTree,
      hoveredCategory,
    };
  },
});
